<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn data-v-step="4" small fab @click="switchView">
          {{ is3d ? "2d" : "3d" }}
        </v-btn>
        <map-view-mode-toggler-help-dialog />
      </div>
    </template>
    <span>{{ is3d ? "Bytt til 2D visning" : "Bytt til 3D visning" }}</span>
  </v-tooltip>
</template>

<script>
import { mapState } from "vuex";
import MapViewModeTogglerHelpDialog from "@/pages/MapPage/Map/MapViewModeTogglerHelpDialog";
export default {
  name: "MapViewmodeToggler",
  data: function() {
    return {};
  },
  components: {
    MapViewModeTogglerHelpDialog
  },
  computed: {
    ...mapState(["is3d", "tools"]),
    disableToggle: function() {
      return this.tools.drawing.active;
    }
  },
  methods: {
    switchView() {
      this.$emit("view-mode-changed");
    }
  },
  mounted() {}
};
</script>

<style>
.vertical-v-btn-toggle {
  flex-direction: column;
}
</style>
